export default __webpack_public_path__ + "static/media/zyla.86deb42c.svg";